import { render, staticRenderFns } from "./ShareComponent.vue?vue&type=template&id=227e0ec6&scoped=true&"
import script from "./ShareComponent.vue?vue&type=script&lang=js&"
export * from "./ShareComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227e0ec6",
  null
  
)

export default component.exports